export default __webpack_public_path__ + "static/media/Kochar Sung-up Acrylic Limited.88dda9b4.jpg";